import React, { ReactElement } from 'react';
import ScannerOverlayImg from '../assets/scanner-overlay.svg';
import { ComponentType, Props } from './';
import './CodeScanner.scss';
// HACK: base64 encoded SVG icons for Scandit default icons replacement
const CODE_SCANNER_ICON = {
  cameraSwitcher:
    'data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTMuOTcyIDNjLjMzOCAwIC42Ni4xMzcuODk2LjM3OWwyLjEzMiAyLjE5MWgyLjVjMS4zOCAwIDIuNSAxLjEyIDIuNSAyLjV2MTAuNDNjMCAxLjM4LTEuMTIgMi41LTIuNSAyLjVoLTE1Yy0xLjM4IDAtMi41LTEuMTItMi41LTIuNXYtMTAuNDI5YzAtMS4zOCAxLjEyLTIuNSAyLjUtMi41aDIuNWwyLjEzMi0yLjE5MWMuMjM1LS4yNDIuNTU4LS4zNzkuODk2LS4zNzloMy45NDR6bTIuNTI4IDcuNjQzLTMgMy4xNDNoMi4xNzR2LjAwNmMtLjE5NiAxLjAwNy0uNzYzIDEuODkzLTEuNTc4IDIuNDY2LS40MDUuMjg3LS44Ni40ODgtMS4zNC41OS0uNS4xMDctMS4wMTQuMTA3LTEuNTEzIDAtLjQ4LS4xMDItLjkzNS0uMzAzLTEuMzQtLjU5LS4xOTktLjE0MS0uMzg1LS4zMDItLjU1NS0uNDhsLTEuMDYgMS4xMTFjLjQ3OC41MDIgMS4wNDUuOTAyIDEuNjY4IDEuMTc5LjMxOC4xNDEuNjUuMjUuOTg3LjMyLjY5Ny4xNSAxLjQxNi4xNSAyLjExMyAwIDEuMzQ0LS4yOTIgMi41MjctMS4xMjIgMy4yOTYtMi4zMTMuMzg0LS41OTUuNjUyLTEuMjY0Ljc5LTEuOTY3LjAyLS4xMDYuMDMyLS4yMTUuMDQ3LS4zMjJoMi4zMTF6bS01LjU1NS0zLjAzM2MtLjMzOS4wNzMtLjY3LjE4LS45ODcuMzIyLS45MzcuNDE2LTEuNzQgMS4xMDgtMi4zMSAxLjk5LS4zODQuNTk2LS42NTMgMS4yNjUtLjc5IDEuOTctLjAyMi4xMDUtLjAzMy4yMTQtLjA0OC4zMjFoLTIuMzFsMyAzLjE0MyAzLTMuMTQzaC0yLjE3NHYtLjAwN2MuMDk4LS41MDIuMjktLjk4LjU2NC0xLjQwNC40MDktLjYzLjk4Mi0xLjEyNCAxLjY1LTEuNDIzLjIyNy0uMS40NjMtLjE3OC43MDQtLjIyOS41LS4xMDYgMS4wMTQtLjEwNiAxLjUxNCAwIC43MTcuMTU0IDEuMzc2LjUyNiAxLjg5MyAxLjA3bDEuMDYyLTEuMTFjLS40NzgtLjUwMS0xLjA0NS0uOTAyLTEuNjY4LTEuMTc5LS4zMTgtLjE0MS0uNjQ4LS4yNDgtLjk4Ni0uMzItLjY5OC0uMTUtMS40MTctLjE1LTIuMTE0IDB6IiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIC8+PC9zdmc+Cg==',
  torchToggle:
    'data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjUgMjQiIHdpZHRoPSIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTUgOXYxNGMwIC41NTItLjQ0OCAxLTEgMWgtNmMtLjU1MiAwLTEtLjQ0OC0xLTF2LTE0em0tNCAyYy0uNTUyIDAtMSAuNDQ4LTEgMXYxYzAgLjU1Mi40NDggMSAxIDFzMS0uNDQ4IDEtMXYtMWMwLS41NTItLjQ0OC0xLTEtMXptNi04LTIgNWgtOGwtMi01em0tLjUtM2MuMjc2IDAgLjUuMjI0LjUuNXYxLjVoLTEydi0xLjVjMC0uMjc2LjIyNC0uNS41LS41eiIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSguNSkiLz48L3N2Zz4K',
};
const CODE_SCANNER_UI_CLASS_NAME = {
  cameraSwitcherIcon: 'scandit-camera-switcher',
  hidden: 'scandit-hidden',
  torchToggleIcon: 'scandit-torch-toggle',
  viewfinder: 'scandit-viewfinder',
};

const CodeScanner: ComponentType = ({
  codeScannerElement,
  isCodeScannerReady,
}: Props): ReactElement => (
  <div className="CodeScanner">
    <div className="CodeScanner-Scanner" ref={codeScannerElement} />

    {isCodeScannerReady && (
      <img
        alt="Scanner Overlay"
        className="CodeScanner-ScannerOverlay"
        src={ScannerOverlayImg}
      />
    )}
  </div>
);

export {
  CODE_SCANNER_ICON,
  CODE_SCANNER_UI_CLASS_NAME,
  CodeScanner,
};
